export {SpinnerModule} from './spinner.module';
export * from './spinner.component';
